/// <reference types="google-publisher-tag" />

'use client';

import { c as _c } from "react/compiler-runtime";
import { useFeatureFlag } from '@posthog/next';
import { useState } from 'react';
import { useMediaQuery } from 'usehooks-ts';
import AdSlot from '@/app/[locale]/(worlds)/[roomId]/components/AdSlot';
import { NATIVE_SEARCH_RESULT_AD_SIZES } from '@/constants/ad';
import { useUAContext } from '@/context/UAContext';
import { useEnableFull3d } from '@/hooks/useEnableFull3d';
import { usePlatformAdFree } from '@/hooks/usePlatformAdFree';
import { env } from '@/lib/runtime-env';
import { cn } from '@/lib/utils';
import { parseAdTelemetryConfig } from '@/schemas/ad-telemetry';
const NATIVE_AD_FLAG_KEY = 'native-ad-search-page';
const NATIVE_AD_UNIT_PATH_ENV_KEYS = {
  mobile: 'NEXT_PUBLIC_GAM_NATIVE_SEARCH_RESULT_PAGE_MB_UNIT_PATH',
  desktopMd: 'NEXT_PUBLIC_GAM_NATIVE_SEARCH_RESULT_PAGE_PC_MD_UNIT_PATH',
  desktopLg: 'NEXT_PUBLIC_GAM_NATIVE_SEARCH_RESULT_PAGE_PC_LG_UNIT_PATH'
} as const;
export default function SearchResultNativeAd() {
  const $ = _c(12);
  const {
    isMobile
  } = useUAContext();
  const {
    isAdFree
  } = usePlatformAdFree();
  const enableFull3d = useEnableFull3d();
  const featureFlag = useFeatureFlag(NATIVE_AD_FLAG_KEY);
  const [hasRenderedAd, setHasRenderedAd] = useState(false);
  const isLgViewport = useMediaQuery("(min-width: 1024px)");
  const desktopUnitKey = isLgViewport ? "desktopLg" : "desktopMd";
  const t0 = NATIVE_AD_UNIT_PATH_ENV_KEYS[isMobile ? "mobile" : desktopUnitKey];
  let t1;
  if ($[0] !== t0) {
    t1 = env(t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const gamAdUnitPath = t1;
  if (featureFlag?.variant !== "test" || isAdFree || enableFull3d || !gamAdUnitPath) {
    return null;
  }
  const t2 = hasRenderedAd ? "p-4 lg:p-0" : "pointer-events-none invisible absolute";
  let t3;
  if ($[2] !== t2) {
    t3 = cn("w-full [&_iframe]:max-w-full", t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== featureFlag.payload) {
    t4 = parseAdTelemetryConfig(featureFlag.payload);
    $[4] = featureFlag.payload;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== gamAdUnitPath || $[7] !== t4) {
    t5 = <AdSlot adSurface="search-result-native" gamAdUnitPath={gamAdUnitPath} sizes={NATIVE_SEARCH_RESULT_AD_SIZES} showAdLabel={false} telemetry={t4} contentClassName="w-full" slotClassName="w-full" onSlotRenderEnded={setHasRenderedAd} />;
    $[6] = gamAdUnitPath;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <div data-component="search-result-native-ad" className={t3}>{t5}</div>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}